/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSetupLogo.css";
import { simpleFetch } from "../../../restWrapper";
import { API_ENDPOINT, PHOTO_PATH, PLATFORM } from "../../../config";
import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import PropTypes from "prop-types";

class OrgSetupLogo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: "",
      loading: true,
      errMsg: "",
    };
  }

  componentDidMount() {
    let logo;
    try {
      logo = this.props.getOrgLogo;
    } catch (e) {
      logo = "";
    } finally {
      this.setState({
        logo: logo,
        loading: false,
      });
    }
  }
  render() {
    const languageObj = this.props.languageObj;

    if (this.state.loading || !languageObj) {
      return <this.props.RenderFullPageLoading />;
    }
    const errObj = languageObj.errMsg;

    const submitData = (e) => {
      try {
        if (this.state.errMsg || this.state.loading || !this.state.logo) {
          this.setState({
            errMsg: errObj[0],
          });
          return false;
        }
        this.setState({
          loading: true,
        });
        return simpleFetch("/organizations", "PUT", {
          logo: this.state.logo,
        }).then((res) => {
          if (res.status !== 200) {
            this.setState({
              errMsg: errObj[0],
              loading: false,
            });
            return false;
          } else {
            return true;
          }
        });
      } catch (e) {
        this.setState({
          errMsg: errObj[1],
          loading: false,
        });
        return false;
      }
    };
    const submitBtn = (e) => {
      try {
        submitData().then((bool) => {
          if (bool) this.props.nextBtn();
        });
      } catch (e) {
        return false;
      }
    };

    const exitBtn = (e) => {
      try {
        submitData().then((bool) => {
          if (bool) this.props.orgLogout();
        });
      } catch (e) {
        this.props.orgLogout();
      }
    };

    const handleLogo = (e) => {
      try {
        if (this.state.loading) return false;
        const file = e.target.files[0];
        if (!file) return false;

        // Check file type
        if (file.type !== "image/png" && file.type !== "image/jpeg") {
          this.setState({
            errMsg:
              PLATFORM === "plug"
                ? "Please upload a PNG or JPEG image file."
                : errObj[0],
          });
          return false;
        }

        // Check file size (max 5MB)
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
          this.setState({
            errMsg:
              PLATFORM === "plug"
                ? "File size must be less than 5MB."
                : "檔案大小必須少於 5MB。",
          });
          return false;
        }

        this.setState({
          errMsg: "",
          loading: true,
        });

        let fileData = new FormData();
        fileData.append("file", file);

        fetch(API_ENDPOINT + "/organizations/s3", {
          credentials: "include",
          method: "POST",
          body: fileData,
        })
          .then((res) => {
            if (!res.ok) {
              // Try to get error message from response
              return res.json().then((body) => {
                const errorMsg =
                  body?.message ||
                  (PLATFORM === "plug"
                    ? "Failed to upload logo. Please try again."
                    : errObj[1]);
                this.setState({
                  errMsg: errorMsg,
                  loading: false,
                });
                throw new Error(errorMsg);
              });
            }
            return res.json();
          })
          .then((body) => {
            if (body && body.id) {
              const logoUrl = PHOTO_PATH + body.id;
              this.setState({
                logo: logoUrl,
                loading: false,
                errMsg: "",
              });
            }
          })
          .catch((err) => {
            // Only set error if not already set
            if (!this.state.errMsg) {
              this.setState({
                errMsg:
                  PLATFORM === "plug"
                    ? "Network error. Please check your connection and try again."
                    : "網絡錯誤，請檢查您的連線並重試。",
                loading: false,
              });
            }
          });
      } catch (e) {
        this.setState({
          errMsg:
            PLATFORM === "plug"
              ? "An error occurred. Please try again."
              : errObj[0],
          loading: false,
        });
      }
    };

    const logoStyle = {
      backgroundImage: "url('" + this.state.logo + "')",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      border: "none",
    };
    const logoText = !this.state.logo ? languageObj.logoText : "";
    return (
      <div className="OrgSetupLogo-view">
        <div className="OrgSetupLogo-center">
          <div className="OrgSetupLogo-header">
            {/* Conditionally render logo based on platform */}
            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSetupLogo-PlugLogo"
                  : "OrgSetupLogo-CheckPlusLogo"
              }
            />

            <div className="OrgSetupLogo-headerBottom">
              <div
                className="OrgSetupLogo-backBtn"
                onClick={this.props.backBtn}
              >
                <div className="OrgSetupLogo-backIcn" />
              </div>

              <div className="OrgSetupLogo-steps">{languageObj.step}</div>
            </div>
          </div>

          <div className="OrgSetupLogo-container">
            <div className="OrgSetupLogo-logoUploader">
              <div className="OrgSetupLogo-logoContainer" style={logoStyle}>
                <input type="file" onChange={handleLogo} />

                <div className="OrgSetupLogo-uploadBtn">{logoText}</div>
              </div>
            </div>
          </div>

          <div className="OrgSetupLogo-logoutTxt" onClick={exitBtn}>
            {languageObj.rightBtn}
          </div>

          <div className="OrgSetupLogo-nextBtn" onClick={submitBtn}>
            <div className="OrgSetupLogo-nextIcnContainer">
              <div className="OrgSetupLogo-nextIcn" />
            </div>

            <div className="OrgSetupLogo-nextText">{languageObj.submitBtn}</div>
          </div>

          {renderErrorMsg(this.state.errMsg)}
        </div>
      </div>
    );
  }
}
OrgSetupLogo.propTypes = {
  RenderFullPageLoading: PropTypes.func,
  backBtn: PropTypes.func,
  nextBtn: PropTypes.func,
  orgLogout: PropTypes.func,
  getOrgLogo: PropTypes.string,
  languageObj: PropTypes.object,
};
export default OrgSetupLogo;
